module.exports = __webpack_public_path__ + "static/assets/479f450a13e2b2e234bef6d04ecdff9b.svg";